import PropTypes from 'prop-types';

export const CategoryType = PropTypes.shape({
  name: PropTypes.string,
  parent: PropTypes.number,
  parent_name: PropTypes.string,
  category_person: PropTypes.string,
  category_person_plural: PropTypes.string,
  seo_key: PropTypes.string,
  id: PropTypes.number,
  parent_id: PropTypes.number
});
